import { api } from './authService';

export type Modalidade = 'pre_recebimento' | 'pos_recebimento';

export interface Cliente {
  nome: string;
  aliases: string[];
  modalidade: Modalidade | '';
  cnpj: string;
  conta_adiantamento: string;
  conta_receber: string;
  conta_receita: string;
  pais: string;
  cep: string;
  cidade: string;
  estado: string;
  logradouro: string;
  moeda_servico: string;
}

export async function getClientes(): Promise<Cliente[]> {
  const res = await api.get<Cliente[]>('/clientes');
  return res.data;
}

export async function getCliente(nome: string): Promise<Cliente> {
  const res = await api.get<Cliente>(`/clientes/${encodeURIComponent(nome)}`);
  return res.data;
}

export type CreateClienteInput = Omit<Cliente, 'modalidade'> & { modalidade: Modalidade };

export async function createCliente(data: CreateClienteInput): Promise<Cliente> {
  const res = await api.post<Cliente>('/clientes', data);
  return res.data;
}

export async function updateCliente(nome: string, data: Partial<Omit<Cliente, 'nome'>>): Promise<Cliente> {
  const res = await api.put<Cliente>(`/clientes/${encodeURIComponent(nome)}`, data);
  return res.data;
}

export async function deleteCliente(nome: string): Promise<void> {
  await api.delete(`/clientes/${encodeURIComponent(nome)}`);
}
